import { Text, Button, Card, styled } from '@/theme/index';

const StyledCard = styled(Card)(() => ({
  position: 'relative',
  padding: 0,
  borderRadius: 0.5,
  cursor: 'pointer',
  height: '348px',
  gap: 2.5,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid #E2E2E2',
  textAlign: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
}));

interface NoFamilyTreePreviewProps {
  handleClick: () => void;
  setHovered: (hovered: boolean) => void;
  imgFamilyTreeBackground?: string;
}

const NoFamilyTreePreview = ({
  handleClick,
  setHovered,
  imgFamilyTreeBackground,
}: NoFamilyTreePreviewProps) => {
  return (
    <StyledCard
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        backgroundImage: imgFamilyTreeBackground
          ? `url(${imgFamilyTreeBackground})`
          : 'none',
      }}
    >
      <Text variant="h4">Add relatives to build out your family tree</Text>
      <Button onClick={() => handleClick()} variant="contained" color="success">
        Add relatives
      </Button>
    </StyledCard>
  );
};

export default NoFamilyTreePreview;
